import { Get, ProjectConfig } from '@/api'

const increment = ProjectConfig.increment

// 从 sessionStorage 读取任务信息
function getTaskInfoFromStorage() {
  try {
    const taskInfoStr = sessionStorage.getItem('currentTaskInfo')
    if (taskInfoStr) {
      return JSON.parse(taskInfoStr)
    }
  } catch (error) {
    console.error('读取任务信息失败：', error)
    sessionStorage.removeItem('currentTaskInfo')
  }
  return null
}

// 保存任务信息到 sessionStorage
function saveTaskInfoToStorage(taskInfo) {
  try {
    if (taskInfo) {
      sessionStorage.setItem('currentTaskInfo', JSON.stringify(taskInfo))
    } else {
      sessionStorage.removeItem('currentTaskInfo')
    }
  } catch (error) {
    console.error('保存任务信息失败：', error)
  }
}

const store = {
  namespaced: true,
  state: {
    magId: '',
    isYZTJ: false, // 是否有引证追踪模块
    // 当前任务信息（完整的 row 对象），从 sessionStorage 恢复
    currentTaskInfo: getTaskInfoFromStorage(),
    progressPages: [],
    templateOptions: [], // 模版风格类型
    magList: [{ label: '中华医学集群', value: 1 }], // 刊物列表
    mailBalance: 0, // 邮箱余额
    showMailBalanceAlert: false, // 是否显示邮箱余额警告
    isPubSync: false, // 是否配置了 "发布同步"
    serviceValidUntil: '', // 服务到期时间
    zdtsChildrenList: [] // 主动推送子菜单列表
  },
  getters: {
    // 获取当前任务信息
    getCurrentTaskInfo: (state) => state.currentTaskInfo,
    // 获取邮箱余额
    getMailBalance: (state) => state.mailBalance,
    // 获取邮箱余额警告状态
    getShowMailBalanceAlert: (state) => state.showMailBalanceAlert,
    // 获取服务到期时间
    getServiceValidUntil: (state) => state.serviceValidUntil,
    // 获取主动推送子菜单列表
    getZdtsChildrenList: (state) => state.zdtsChildrenList
  },
  mutations: {
    setMagId: (state, value) => {
      state.magId = value
    },
    setIsYZTJ: (state, value) => {
      state.isYZTJ = value
    },
    // 设置当前任务信息
    setCurrentTaskInfo: (state, taskInfo) => {
      state.currentTaskInfo = taskInfo
      // 同时保存到 sessionStorage
      saveTaskInfoToStorage(taskInfo)
    },
    // 清除任务信息
    clearCurrentTaskInfo: (state) => {
      state.currentTaskInfo = null
      // 同时清除 sessionStorage
      saveTaskInfoToStorage(null)
    },
    // 更新步骤条
    updataProgressPages: (state, arr) => {
      state.progressPages = arr
    },
    // 更新templateOptions
    settemplateOptions: (state, options) => {
      state.templateOptions = options
    },
    // 设置邮箱余额
    setMailBalance: (state, value) => {
      state.mailBalance = value
    },
    // 设置邮箱余额警告状态
    setShowMailBalanceAlert: (state, value) => {
      state.showMailBalanceAlert = value
    },
    // 设置发布同步状态
    setIsPubSync: (state, value) => {
      state.isPubSync = value
    },
    // 设置服务到期时间
    setServiceValidUntil: (state, value) => {
      state.serviceValidUntil = value
    },
    // 设置主动推送子菜单列表
    setZdtsChildrenList: (state, value) => {
      state.zdtsChildrenList = value
    }
  },
  actions: {
    magIdFun({ commit }, value) {
      commit('setMagId', value)
    },
    isYZTJFun({ commit }, value) {
      commit('setIsYZTJ', value)
    },
    zdtsChildrenListFun({ commit }, value) {
      commit('setZdtsChildrenList', value)
    },
    // 设置任务信息
    setTaskInfo({ commit }, taskInfo) {
      commit('setCurrentTaskInfo', taskInfo)
    },
    // 清除任务信息
    clearTaskInfo({ commit }) {
      commit('clearCurrentTaskInfo')
    },
    // 更新任务信息
    async updataTaskInfo({ commit }, taskId) {
      return new Promise((resolve, reject) => {
        console.log(taskId, 'taskId')
        if (!taskId) {
          commit('setCurrentTaskInfo', null)
          return
        }
        try {
          Get(increment.GetTaskDetail.url, {
            params: {
              taskId: taskId
            }
          })
            .then((res) => {
              if (res.data.status === 0) {
                commit('setCurrentTaskInfo', res.data.data)
                resolve(res.data.data)
              }
            })
            .catch((error) => {
              console.error('更新任务信息失败：', error)
              reject(error)
            })
        } catch (error) {
          console.error('更新任务信息失败：', error)
          throw error
        }
      })
    },
    // 获取邮箱余额并判断是否需要警告
    async fetchMailBalance({ commit }) {
      try {
        // const magazineInfo = rootGetters['micro/magazine/MAGAZINE_INFO']
        // console.log(magazineInfo, 'magazineInfo')
        const res = await Get(increment.GetMailBalanceDetail.url)
        if (res?.data?.status === 0) {
          const data = res.data.data
          const mailBalance = data?.mailBalance || 0
          commit('setMailBalance', mailBalance)
          commit('setShowMailBalanceAlert', mailBalance < 2000)
        }
      } catch (error) {
        console.error('获取邮箱余额失败：', error)
      }
    },
    // 获取发布同步状态
    async fetchIsPubSync({ commit }) {
      try {
        const res = await Get(increment.getCrawlMagId.url)
        if (res?.data?.status === 0) {
          const dataSource = res.data.data?.dataSource
          commit('setIsPubSync', dataSource == 4)
          // 获取服务到期时间
          const serviceValidUntil = res.data.data?.serviceValidUntil || ''
          commit('setServiceValidUntil', serviceValidUntil)
        }
      } catch (error) {
        console.error('获取发布同步状态失败：', error)
      }
    }
  }
}

export default store
